import { IModel, IAttribute } from '../base/annotation';
import { Metamodel } from 'app/model/base/model';
import { TypeFormat } from '../dataset/type-format';
import { UniqueArray } from 'shell-models-lib';


export interface IJSONPathDefinition {
    columnName: string;
    jsonPath: string;
}

@Metamodel.model({})
export class JSONFormat extends TypeFormat {
    public static readonly MODEL: IModel;
    public static readonly NESTING_SEPARATOR: IAttribute;

    @Metamodel.attribute({
        display: stringResources.NestingSeparatorFieldLabel,
        templatable: true,
        association: 'NESTING_SEPARATOR'
    })
    public nestingSeparator?: string;

    public filePattern?: string;
    public jsonNodeReference?: string;
    public jsonPathDefinition = UniqueArray.createUniqueArray<IJSONPathDefinition>();
}
